import * as Scrivito from "scrivito";
import defaultFormInputAttributes from "../../_defaultFormAttributes";

const TextAreaWidget = Scrivito.provideWidgetClass("TextAreaWidget", {
  attributes: {
    ...defaultFormInputAttributes,
    placeholder: "string",
  },
  onlyInside: "FormPageWidget",
});

export default TextAreaWidget;
